
<div class="w-100 d-flex justify-content-center">
    <div class="avs-barrier-control-warn-container">
        <img class="bg-white" width ="50" src="assets/icons/exclamation-circle-danger.svg">
    </div>
    <div class="w-100 d-flex justify-content-center">
        <p class="text-danger">Vor dem Auslösen eines Fahrbefehls muss sichergestellt sein, dass der Fahrbereich frei ist ! </p>
    </div>
</div>
<div class="w-100 d-flex justify-content-center mb-2">
    <button [disabled]="!isMoveToOpenEnabled()" class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="moveToOpen()"> Öffnen </button>
    <button [disabled]="!isMoveToCloseEnabled()" class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="moveToClose()"> Schließen </button>
    <button [disabled]="!isStopEnabled()" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="stopMoving()"> Stop </button>
</div>
